import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const ToolbarItemRotateIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M6.71 17.29L4.67 19.33C2.73 17.4 1.62 14.8 1.62 12C1.62 6.28 6.28 1.62 12 1.62C12.35 1.62 12.62 1.34 12.62 1C12.62 0.660005 12.34 0.380005 12 0.380005C5.59 0.380005 0.380005 5.59 0.380005 12C0.380005 15.13 1.61 18.04 3.79 20.21L2.19 21.81C1.76 22.24 2.06001 22.98 2.68001 22.98H7.21C7.59 22.98 7.9 22.67 7.9 22.29V17.76C7.9 17.15 7.16 16.84 6.73 17.27L6.71 17.29Z"
        fill={color}
      />
      <path
        d="M20.21 3.79002L21.81 2.19002C22.24 1.76002 21.94 1.02002 21.32 1.02002H16.79C16.41 1.02002 16.1 1.33002 16.1 1.71002V6.24002C16.1 6.85002 16.84 7.16002 17.27 6.73002L19.32 4.68002C21.26 6.61002 22.36 9.21002 22.36 12.01C22.36 17.73 17.71 22.39 11.98 22.39C11.63 22.39 11.36 22.67 11.36 23.01C11.36 23.35 11.64 23.63 11.98 23.63C18.39 23.63 23.6 18.42 23.6 12.01C23.6 8.87002 22.37 5.96002 20.19 3.80002L20.21 3.79002Z"
        fill={color}
      />
      <path
        d="M12.38 16.65L15.82 14.65C16.05 14.52 16.19 14.27 16.19 14V10C16.19 9.73 16.05 9.49 15.82 9.35L12.38 7.35C12.15 7.21 11.86 7.21 11.63 7.35L8.19001 9.35C7.96001 9.48 7.82001 9.73 7.82001 10V14C7.82001 14.27 7.96001 14.51 8.19001 14.65L11.63 16.65C11.86 16.79 12.15 16.79 12.38 16.65ZM9.31001 10.43L12 8.87L14.69 10.43V13.57L12 15.13L9.31001 13.57V10.43Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ToolbarItemRotateIcon.displayName = 'ToolbarItemRotateIcon';
